import AWS from 'aws-sdk';

import * as GlobalConstants from '../data/GlobalConstants.js';

AWS.config.update({
    accessKeyId: GlobalConstants.AWS_ACCESS_KEY,
    secretAccessKey: GlobalConstants.AWS_SECRET_KEY,
    region: GlobalConstants.AWS_REGION_NAME
});

const cognito = new AWS.CognitoIdentityServiceProvider();

async function getCognitoUserByEmail(email) {
        if(!email) {
            throw new Error (GlobalConstants.EMAIL_COGNITO_API_ERROR);
        }

        const params = {
            UserPoolId: GlobalConstants.AWS_USER_POOL_ID,
            Filter: `email = "${email}"`,
            Limit: 1
        };
        
    return await cognito.listUsers(params).promise();
};

// TODO: remove "getCognitoUserByEmail" method to mantain this since
//       this one returns the unique user and not a list
async function getUserByEmail(email) {
    if(!email) {
        throw new Error (GlobalConstants.EMAIL_COGNITO_API_ERROR);
    }

    const params = {
        UserPoolId: GlobalConstants.AWS_USER_POOL_ID,
        Filter: `email = "${email}"`,
        Limit: 1
    };

    const response = await cognito.listUsers(params).promise();

    return (response.Users.length>0) ? response.Users[0] : null;
};

async function processUserEmailVerification(email) {
    try {
        const user = await getUserByEmail(email);
        const emailAttribute = user.Attributes.find(attr => attr.Name === 'email_verified');
        const verified = (emailAttribute && emailAttribute.Value==='true');

        if(!verified){
            await resendVerificationEmail(user.Username);
            return false;
        }

        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};

async function resendVerificationEmail(username) {
    const params = {
        ClientId: GlobalConstants.AWS_USER_POOL_WEB_CLIENT_ID,
        Username: username,
    };

    await cognito.resendConfirmationCode(params).promise();
}

async function verifyConfirmationCode(email, confirmationCode) {
    const user = await getUserByEmail(email);
    const params = {
      ClientId: GlobalConstants.AWS_USER_POOL_WEB_CLIENT_ID, // Replace with your app client ID
      Username: user.Username,
      ConfirmationCode: confirmationCode,
    };

    try {
        await cognito.confirmSignUp(params).promise();
    } catch (error) {
        if(error.code==='CodeMismatchException'){
            return false;
        }
        throw error;
    }

    return true;
};

export { getCognitoUserByEmail, getUserByEmail, processUserEmailVerification, resendVerificationEmail, verifyConfirmationCode };
